import { TransProp } from '@icc/shared/helpers';
import { RollerGuideCap } from './guide-cap';

/** Prowadzenia */
export class RollerGuidesCaps {
    id: number;
    /** Id żaluzji */
    shutterId: number;
    /** Lewe prowdzenie.
     *
     * Gdy jest przygotowanie pod prowadzenie to jest równe `null`
     */
    @TransProp()
    left: RollerGuideCap | null;
    /**
     * Prawe prowadzenie
     *
     * Gdy jest przygotowanie pod prowadzenie to jest równe `null`
     */
    @TransProp()
    right: RollerGuideCap | null;

     /** Prowadzenia podziałowe moskitier */
    mosquitoScreens: {
        cap: RollerGuideCap;
        leftMosquitoScreenId: number | null;
        rightMosquitoScreenId: number | null;
    }[];
}
